import { Box, useTheme } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';

import { styles } from './LoaderStyles';

const Loader = () => {
  const theme = useTheme();
  const classes = styles(theme);

  return (
    <Box sx={classes.container}>
      <CircularProgress sx={classes.loader} />
    </Box>
  );
};

export default Loader;
